import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface FullBonusCode {
	codeId: number
	code: string
	description: string
	isRepeated: boolean
	isDisabled: boolean
}
export interface TimeSheetBenefitCodesState {
	bonusCodes: FullBonusCode[]
}

const initialState: TimeSheetBenefitCodesState = {
	bonusCodes: [],
}
export const timesheetBonusCodeSlice = createSlice({
	name: 'timesheetBonusCodes',
	initialState,
	reducers: {
		changeBonus: (state, action: PayloadAction<Partial<TimeSheetBenefitCodesState>>) => {
			Object.assign(state, action.payload)
		},
	},
})

export const { changeBonus } = timesheetBonusCodeSlice.actions
